import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useUpdateStudentKartesCache } from "../../../../hooks/http/useFetchStudentKartes";

export const useDeleteKartePin = () => {
  const { refetchStudentKartes } = useUpdateStudentKartesCache();

  return useBoronMutation(
    async ({ studentId, karteId }: { studentId: string; karteId: string }) =>
      await boronClient.DELETE(
        "/api/v1/students/{student_id}/kartes/{karte_hashid}/pin",
        {
          params: {
            path: {
              student_id: studentId,
              karte_hashid: karteId,
            },
          },
        },
      ),
    {
      onSuccess: (_, { studentId }) => {
        // 生徒カルテ一覧を再取得する
        refetchStudentKartes(studentId);
      },
    },
  );
};
